import Cookie from './Cookie';

class Geolocation {

    static localize() {

        return new Promise((accept, reject) => {

            if (!navigator.geolocation)
                return reject('Geolocation Not Available')

            // Try To Retrieve Position From Cache
            let cache = this.getCache()
            if(cache) accept(cache)

            // Geolocation
            navigator.geolocation.getCurrentPosition((pos) => {
                let position = {
                    lat: pos.coords.latitude,
                    lng: pos.coords.longitude
                }

                this.setCache(position)

                accept(position)

            }, (err) => {
                reject(err)
            });
        })
    }

    static setCache(value) {
        Cookie.setCookie('_geoloc', JSON.stringify(value), 10)
    }

    static getCache() {

        let cookie = Cookie.getCookie('_geoloc')

        if(cookie)
            return JSON.parse(cookie)

        return null
    }

}

export default Geolocation


// WEBPACK FOOTER //
// ./resources/assets/js/modules/Geolocation.js